
const appVersion = import.meta.env.VITE_APP_VERSION;
const packageVersion = import.meta.env.VITE_APP_PACKAGE_VERSION;

export const useGetVersion = (): [string] => {
  return [appVersion ?? packageVersion ?? '0.0.0'];
}
